const pagesTitles = {
  adminsManagement: 'Admins management',
  admins: 'List admins',
  adminsAdd: 'Add new admin',
  adminsEdit: 'Edit admin',
  categoriesManagement: 'Service providers categories management',
  serviceProviderCategories: 'List categories',
  serviceProviderCategoriesAdd: 'Add new category',
  serviceProviderCategoriesEdit: 'Edit category',
  serviceProviderCategoriesView: 'View category',
  specialtiesManagement: 'Specialties management',
  specialties: 'List specialties',
  specialtiesAdd: 'Add new specialty',
  specialtiesView: 'View specialty',
  specialtiesEdit: 'Edit specialty',
  servicesManagement: 'Services management',
  services: 'List services',
  servicesAdd: 'Add new service',
  servicesEdit: 'Edit service',
  lookupsManagement: 'Lookups management',
  lookupsRequests:'Lookups requests',
  serviceProvidersManagement: 'Service providers management',
  branchesManagement: 'Branches management',
  serviceProviders: 'List service providers',
  serviceProvidersAdd: 'Add new service provider',
  serviceProvidersEdit: 'Edit service provider',
  serviceProvidersView: 'View service provider',
  addProviderBranchEmployees: 'Branch employees',
  employeesManagement: 'Employees management',
  customersManagement: 'Customers management',
  employees: 'List employees',
  customers: 'List customers',
  employeesAdd: 'Add new employee',
  employeesEdit: 'Edit employee',
  branchManagement: 'Branches management',
  branches: 'List branches',
  publishRequests: 'Publish requests',
  bookings: 'List bookings',
  bookingsManagement: 'Bookings management',
  addProviderBranch: 'Add new branch',
  editProviderBranch: 'Edit branch details',
  editProviderBranchServicesAndSpecialties: 'Edit branch services & specialties',
  editProviderBranchEmployee: 'Edit branch employee',
  AddBranch: 'Add branch',
  editBranch:'Edit branch',
  viewBranch: 'View branch',
  branchTabOne: 'View branch details',
  branchTabTwo: 'View branch specialties & services',
  branchTabThree: 'View branch employees',
  branchTabFour: 'Bookings list',
  SupportedRegions: 'Supported districts',
  SelectLocationFromMap: 'Select location from map',
  addProviderBranchSpecialties: 'Specialties & Services',
  SettingsManagment: 'Settings',
  employeeView: 'View employee',
  customerView: 'View customer',
  notificationsManagement: 'Notifications management',
  paymentTransactionsManagement: 'Payment transactions management',
  paymentTransactions:'Payment transactions list',
  settlementsManagement: 'Settlements management',
  settlements: 'Settlements list',
  mimarProfit: 'Mimar profit',
  profitOverview: 'Profit Overview',
};

export default pagesTitles;
